import { forwardRef } from 'react';
import { oneLine } from 'common-tags';

import styles from './Link.module.css';

import type { ComponentPropsWithRef } from 'react';
import type { LinkProps } from './types';

import '@/lib/utils/forwardRef';

const LinkAbstract = <T extends React.ElementType = 'a'>(
  {
    as,
    type = 'primary',
    size = 'small',
    className = '',
    children,
    ...props
  }: LinkProps<T> & Omit<ComponentPropsWithRef<T>, keyof LinkProps<T>>,
  ref: React.Ref<HTMLAnchorElement>,
) => {
  const HTMLTag = as || 'a';

  return (
    <HTMLTag
      ref={ref}
      className={oneLine`
        ${styles['o-link']}
        ${styles[`o-link--${size}`]}
        ${styles[`o-link--${type}`]}
        ${className}
      `}
      {...props}
    >
      {children}
    </HTMLTag>
  );
};

export const Link = forwardRef(LinkAbstract);
